/* global google */

import styles from './styles';
import { loadScript } from '../../utils/load-script';

let callbacks = [];
let isLoading = false;

const API_KEY = 'AIzaSyAHRhyV_RRcmadEnW3KVDPUUvSEC5q3cDk';
const SCRIPT_URL = 'https://maps.googleapis.com/maps/api/js';

export function isGoogleMapsLoaded() {
	return typeof google === 'object' && typeof google.maps === 'object';
}

export function defer(callback) {
	let url = `${SCRIPT_URL}?key=${API_KEY}`;

	if (isGoogleMapsLoaded()) {
		return callback();
	}

	callbacks.push(callback);

	if (isLoading) {
		return;
	}

	isLoading = true;

	loadScript(url, function onLoad() {
		isLoading = false;

		for (let i = 0; i < callbacks.length; i++) {
			(callbacks.pop())();
		}
	});
}

export function createMap(canvas, options) {
	if (!(canvas instanceof HTMLElement)) {
		return false;
	}

	const defaults = {
		disableDefaultUI: true,
		mapTypeControl: false,
		styles: styles,
		zoom: 10,
		zoomControl: true,
	};

	return new google.maps.Map(canvas, {
		...defaults,
		...options,
	});
}

export function createMarkerIcon(type = 'default') {
	return `/assets/icons/markers/${type}.svg`;
}
